import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import * as OccupationHelper from '@/components/8_JobAssetInvestment/OccupationHelper'; // 假設的路徑
import * as AddressHelper from '@/libs/AddressHelper'; // 假設的路徑
/**
 * @description 職業與資產投資資料介面
 */
export declare interface IJobAssetInvestmentResult {
    //職業狀況
    occupationCode_Collection: Array<OccupationHelper.OccupationRow>; //職業狀況 OccupationRow
    occupationCode: string;

    //職業狀況其他
    occupationOther: string;

    //行業類別代號
    occupationId_Collection: Array<OccupationHelper.JobRow>;
    occupationId: string;

    // 公司
    companyName: string;
    companyTelephone: string;
    companyTelephoneExt: string;
    emergencyContactPhone: string; // 緊急聯絡人電話
    mobilephone: string; // 手機

    // 職務工作
    jobTitleParentCode_Collection: Array<OccupationHelper.JobTitleParentRow>; // 職務工作 Parent
    jobTitleParentCode: string; // 職務工作 Parent
    jobTitleCode: string; // 職務工作
    jobTitleOther: string; // 職務工作 - 其他

    // 投資經歷
    bolInvestmentExp: string;
    yrsStockExp: string;
    yrsBondExp: string;
    yrsRealEstateExp: string;
    yrsFutureExp: string;
    yrsOtherExpDetail: string;
    yrsOtherExp: string;
    amountYearlyIncome: string;
    amountFamilyIncome: string;
    mainMoneySource: string;
    mainMoneySourceDetail: string;
    bolOwnHouse: string;
    amountHouseValue: string;
    bolHasMortgage: string;
    amountMortgage: string;
    bolDepositeMonthEndLeft: string;
    amountDepositeMonthEndLeft: string;
    bolOtherAsset: string;
    otherAssetDetail: string;
    amountOtherAsset: string;
    amountTotalAsset: string;
}

/**
 * @description API 回應結構，包含通用回應和特定資料
 */
export interface JobAssetInvestmentViewDataResp extends GeneralResp {
    result: IJobAssetInvestmentResult;
}

// 注意：原始的 OtpBaseData 介面已被移除，如果 API 函數或其他地方仍需使用，
// 需要將其移至適當的位置或重新定義。

/**
 * @todo 出入金帳號約定/證明文件上傳 ViewData
 */
const JobAssetInvestmentViewData = (): Promise<JobAssetInvestmentViewDataResp> => {
    const url = RouteUrlList.API_JobAssetInvestmentViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<JobAssetInvestmentViewDataResp>) => {
        return res.data;
    });
};

export default JobAssetInvestmentViewData;
